export default __webpack_public_path__ + "static/media/dashboard-icon.94b2f3e8.svg";